import { createSelector, createStateHook } from 'react-sweet-state';

import { store } from '../../main';
import type { IssueAdjustmentsState } from '../../types';

const selectFormMetadata = createSelector(
	(state: IssueAdjustmentsState) => state.internalFormMetadata,
	(metadata) => metadata,
);

export const useFormMetadata = createStateHook(store, {
	selector: selectFormMetadata,
});
